module.exports = __webpack_public_path__ + "static/img/logo_37.7168d82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_37.png
// module id = CflS
// module chunks = 1